import { CSSProperties } from 'react';
import { IApplication } from '../../../Interfaces/Application/IApplication';
import { IApplicationQuote } from '../../../Interfaces/Application/IApplicationQuote';

export const getHelperText = (
  field: RuleViolationFieldId,
  applicationQuote?: IApplicationQuote, 
  currentApp?: IApplication
  ) => {
    const currentMsg = applicationQuote?.ruleViolations?.find(rv => rv.displayFieldId === field)?.summary;
    const longestMsg = currentApp?.applicationQuotes?.reduce((prev, curr) => {
    const summary = curr.ruleViolations?.find(rv => rv.displayFieldId === field)?.summary || '';
    return summary.length > prev.length ? summary : prev;
  }, '') || '';
  return currentMsg || longestMsg;
};

export const getHelperTextProps = (
  field: RuleViolationFieldId,
  applicationQuote?: IApplicationQuote
  ) => {
  const currentMsg = applicationQuote?.ruleViolations?.find(rv => rv.displayFieldId === field)?.summary;
  return currentMsg ? undefined : { style: { visibility: 'hidden' } as CSSProperties } ;
};

export type RuleViolationFieldId =
  | 'ltv'
  | 'paymentToIncome'
  | 'debtToIncome'
  | 'carSalePrice'
  | 'discount'
  | 'deferredDown'
  | 'tradeAllowance'
  | 'tradeLien'
  | 'fees'
  | 'taxes'
  | 'other'
  | 'cashDown'
  | 'amountToFinance'
  | 'monthlyPayment'
  | 'nadavalue'
  | 'term'
  | 'bureauScore'
  | 'netIncome'
  | 'tierField'
  | 'apr'
  | 'lenderFees'
  ;
  